import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import apiClient from '../api/axios';

const ConfirmParticipationPage = () => {
    const { token } = useParams();
    const [message, setMessage] = useState('Подтверждение участия...');
    const [error, setError] = useState('');

    useEffect(() => {
        if (token) {
            apiClient.get(`/participants/confirm/${token}`)
                .then(response => {
                    setMessage(response.data.message);
                })
                .catch(err => {
                    setError(err.response?.data?.detail || 'Произошла ошибка при подтверждении.');
                });
        }
    }, [token]);

    return (
        <div className="container mt-5">
            <div className="row justify-content-center">
                <div className="col-md-6">
                    <div className="card text-center">
                        <div className="card-body">
                            {error ? (
                                <div className="alert alert-danger">{error}</div>
                            ) : (
                                <div className="alert alert-success">{message}</div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfirmParticipationPage;
